import React from 'react';
import logo from 'assets/img/logo-breathe.svg';
import logoMobile from 'assets/img/logo-mobile-breathe.svg';
import { Hidden, HiddenPropsBreakpoint, Visible } from 'extended-oxygen-elements';

type Props = {
  desktopBreakpoint: HiddenPropsBreakpoint;
};

export default function Logo({ desktopBreakpoint }: Props) {
  return (
    <>
      <Visible up={desktopBreakpoint}>
        <img src={logo} alt="Logo" data-testid="rosterHeader-logo" />
      </Visible>

      <Hidden up={desktopBreakpoint}>
        <img src={logoMobile} alt="Mobile logo" data-testid="rosterHeader-logoMobile" />
      </Hidden>
    </>
  );
}
